'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextItem = function (_React$Component) {
  (0, _inherits3.default)(TextItem, _React$Component);

  function TextItem() {
    (0, _classCallCheck3.default)(this, TextItem);
    return (0, _possibleConstructorReturn3.default)(this, (TextItem.__proto__ || (0, _getPrototypeOf2.default)(TextItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(TextItem, [{
    key: 'getTextDimensions',
    value: function getTextDimensions() {
      var _props = this.props,
          style = _props.style,
          styleParams = _props.styleParams,
          cubeRatio = _props.cubeRatio;

      var isVerticalItem = style.ratio < cubeRatio - 0.01;
      //text dimensions include scaling
      var transform = 'translate(0, 0) scale(' + (isVerticalItem ? style.height / style.maxHeight : style.width / style.maxWidth) + ')';
      return {
        margin: Math.floor(style.maxHeight - style.height) / -2 + 'px ' + Math.floor(style.maxWidth - style.width) / -2 + 'px',
        width: style.maxWidth + 'px',
        height: style.maxHeight + 'px',
        WebkitTransform: transform,
        MsTransform: transform,
        OTransform: transform,
        transform: transform
      };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.actions.setItemLoaded();
    }
  }, {
    key: 'processInnerhtml',
    value: function processInnerhtml(html) {
      // Remove html class name from inner html elements
      // In older version of the text editor we used font themes (set as classes). Without the iframe it clashes with Santa's css
      try {
        return html.replace(/class=\"font_\d+\"/gm, '');
      } catch (e) {
        return html;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          visible = _props2.visible,
          id = _props2.id,
          styleParams = _props2.styleParams,
          html = _props2.html,
          style = _props2.style,
          actions = _props2.actions,
          imageDimensions = _props2.imageDimensions;

      var processedHtml = this.processInnerhtml(html);
      var dimensions = this.getTextDimensions();
      var htmlParam = { dangerouslySetInnerHTML: { __html: processedHtml } };
      var styleIsDimensions = { style: { dimensions: dimensions } };
      var changeBgColor = { style: (0, _assign2.default)(dimensions, styleParams.cubeType === 'fit' ? { backgroundColor: style.bgColor } : {}) };
      var show = visible || styleParams.hasThumbnails;
      var attributes = show ? (0, _extends3.default)({}, htmlParam, changeBgColor) : (0, _extends3.default)({}, styleIsDimensions);
      var itemContentStyle = {
        height: imageDimensions ? imageDimensions.height : 'inherit',
        backgroundColor: styleParams.cubeType !== 'fit' ? style.bgColor : 'inherit'
      };

      return _react2.default.createElement(
        'div',
        { className: 'gallery-item-content', style: itemContentStyle },
        _react2.default.createElement('div', (0, _extends3.default)({ className: 'gallery-item-visible gallery-item gallery-item-loaded text-item',
          key: 'item-text-' + id,
          onTouchStart: actions.handleItemMouseDown,
          onTouchEnd: actions.handleItemMouseUp,
          'data-hook': 'text-item'
        }, attributes))
      );
    }
  }]);
  return TextItem;
}(_react2.default.Component);

exports.default = TextItem;